// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-6e39c5dd] {\n  height: 100%;\n}\n.container header[data-v-6e39c5dd] {\n    line-height: 70px;\n    font-size: 24px;\n    border-bottom: 2px solid #ccc;\n}\n.container header .title[data-v-6e39c5dd] {\n      max-width: 1200px;\n      margin: auto;\n}\n.container .content[data-v-6e39c5dd] {\n    height: 100%;\n    max-width: 1200px;\n    margin: auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n", ""]);
// Exports
module.exports = exports;
